/**
 * Estilos compartidos de modales / diálogos Conecta2.
 * Usar en Dialog, Modal y botones de acción para mantener un solo diseño.
 */
export const C2_FONT = "'Outfit', 'Poppins', sans-serif";

export const c2DialogPaperSx = {
  borderRadius: '16px',
  border: '1px solid #D7CFEB',
  boxShadow: '0 16px 40px rgba(26,15,59,0.18)',
  maxWidth: 420,
  width: '100%',
  overflow: 'hidden',
  backgroundColor: '#FBFAFE',
  position: 'relative',
  '&::before': {
    content: '""',
    display: 'block',
    height: 4,
    width: '100%',
    background: 'linear-gradient(90deg, #6411ED 0%, #7628FF 100%)',
  },
};

/** Box/paper dentro de MUI Modal (misma apariencia que Dialog). */
export const c2ModalBoxSx = {
  ...c2DialogPaperSx,
  outline: 'none',
  p: { xs: 2.5, sm: 3 },
  maxWidth: 440,
  mx: 2,
  position: 'relative',
};

export const c2DialogTitleSx = {
  fontFamily: C2_FONT,
  fontWeight: 800,
  fontSize: '1.05rem',
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  color: '#1A0F3B',
  pt: 2.25,
  pb: 1,
  px: 2.5,
  display: 'flex',
  alignItems: 'center',
  gap: 1.25,
};

export const c2DialogBodySx = {
  fontFamily: C2_FONT,
  fontSize: '0.95rem',
  color: '#766293',
  lineHeight: 1.5,
};

export const c2IconBoxSx = {
  width: 40,
  height: 40,
  borderRadius: '12px',
  backgroundColor: '#EBE7FB',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
};

export const c2PrimaryBtnSx = {
  fontFamily: C2_FONT,
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
  borderRadius: '12px',
  px: 2.5,
  py: 1,
  background: 'linear-gradient(90deg, #6411ED 0%, #7628FF 100%)',
  boxShadow: '0 6px 16px rgba(100,17,237,0.28)',
  color: '#FBFAFE',
  '&:hover': {
    background: 'linear-gradient(90deg, #5B0FD9 0%, #6D1FF0 100%)',
  },
};

export const c2SecondaryBtnSx = {
  fontFamily: C2_FONT,
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
  borderRadius: '12px',
  px: 2.5,
  py: 1,
  borderColor: '#D7CFEB',
  color: '#1A0F3B',
  backgroundColor: 'transparent',
  '&:hover': {
    borderColor: '#6411ED',
    backgroundColor: '#EBE7FB',
  },
};

export const c2DangerBtnSx = {
  ...c2SecondaryBtnSx,
  borderColor: 'rgba(239,68,68,0.45)',
  color: '#B91C1C',
  '&:hover': {
    borderColor: '#EF4444',
    backgroundColor: 'rgba(239,68,68,0.08)',
  },
};

export const c2SuccessBtnSx = {
  ...c2PrimaryBtnSx,
  background: 'linear-gradient(135deg, #22C55E 0%, #16A34A 100%)',
  boxShadow: '0 6px 16px rgba(34,197,94,0.28)',
  '&:hover': {
    background: 'linear-gradient(135deg, #16A34A 0%, #15803D 100%)',
  },
};

export const c2TextFieldSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '12px',
    fontFamily: C2_FONT,
    backgroundColor: '#FBFAFE',
    '& fieldset': { borderColor: '#D7CFEB' },
    '&:hover fieldset': { borderColor: '#B8A9E0' },
    '&.Mui-focused fieldset': { borderColor: '#6411ED', borderWidth: 2 },
  },
  '& .MuiInputLabel-root': { fontFamily: C2_FONT, color: '#766293' },
  '& .MuiInputLabel-root.Mui-focused': { color: '#6411ED' },
  '& .MuiInputBase-input': { fontFamily: C2_FONT, color: '#1A0F3B' },
};
